import type { ICreditCard } from "@/data/model/CreditCard";
import type { IPaymentMethod } from "@/data/model/Customer";
import { Format } from "@/data/util/Format";

import { clientLanguage } from "@/shared/localization/language";

import { MomentumScroller } from "@/app/ui/MomentumScroller";
import {PaymentProvider} from "@/data/model/Enums";

export class QuickPaymentMethodSelector {
    public onSelect?: { (selectedMethod?: IPaymentMethod, withToken?: ICreditCard): any };

    private readonly $element: JQuery;
    private readonly $methodSlidable: JQuery;
    private methodSliderQuickPayments: MomentumScroller;

    constructor() {
        this.$element = $('<div class="quick-payment-method-selector" />');

        const methodSliderContainer = $('<div class="methodslider" />').appendTo(this.$element);

        this.$methodSlidable = $('<div class="slidable dragable quick-payments" />').appendTo(methodSliderContainer);

        this.methodSliderQuickPayments = new MomentumScroller(this.$methodSlidable, {
            axis: "x",
            restrictTo: methodSliderContainer,
        });
    }
    
    public setVisibility(visible: boolean) {
        if (visible) {
            this.$element.show();
        } else {
            this.$element.hide();
        }
    }

    public setDisabled(): QuickPaymentMethodSelector {
        if (!this.isDisabled()) {
            this.$element.addClass("disabled");
        }

        $(".method").each(function (i, obj) {
            $(obj).prop("disabled", true);
        });

        return this;
    }

    public setEnabled(): QuickPaymentMethodSelector {
        this.$element.removeClass("disabled");

        $(".method").each(function (i, obj) {
            $(obj).prop("disabled", false);
        });

        return this;
    }

    public isDisabled(): boolean {
        return this.$element.hasClass("disabled");
    }

    public setPaymentMethodButtons(paymentMethods: Array<IPaymentMethod>) {
        this.$methodSlidable.empty();

        if (paymentMethods.length === 0) this.$element.addClass("hidden");
        else this.$element.removeClass("hidden");

        for (const meth of paymentMethods) {
            const methCont = $('<button class="method" />').data("model", meth).appendTo(this.$methodSlidable);

            if (meth.imagePath !== undefined)
                methCont.append('<div class="icon" style="background-image:url(\'' + meth.imagePath + "');\" />");
            else if (meth.provider === PaymentProvider.Stripe || meth.provider === PaymentProvider.Wallee || meth.provider === PaymentProvider.PostFinance)
                methCont.append('<div class="icon"><i class="fal fa-credit-card"></i></div>');
            else {
                methCont.addClass("nameOnly");
                methCont.append(`<div>${Format.translate(meth.localizedName, clientLanguage())}</div>`);
            }

            methCont.bind("click", (e) => {
                if (!this.isDisabled()) {
                    const model = $(e.currentTarget).data("model") as IPaymentMethod;
                    this.onSelectMethod(model);
                }
            });

            // add method type to the element
            methCont.attr("data-method-type", meth.type);
        }

        this.methodSliderQuickPayments.updateBounds();
    }

    private onSelectMethod(method: IPaymentMethod) {
        if (this.onSelect !== undefined) {
            this.onSelect(method);
        }
    }

    public appendTo($element: JQuery): QuickPaymentMethodSelector {
        this.$element.appendTo($element);
        return this;
    }
}
